exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-group-text[data-v-525c0780] {\n  background-color: #007bff;\n  color: #fff;\n}\n.b-modal[data-v-525c0780] {\n  text-align: center;\n}\n.list-group-item[data-v-525c0780] {\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n}\n.b-modal-header[data-v-525c0780] {\n  background-color: #007bff;\n  color: #fff;\n}\n.b-modal-body[data-v-525c0780] {\n  padding: 2rem;\n}\n.b-modal-footer[data-v-525c0780] {\n  display: none;\n}\n", ""]);

// exports
